import sw from '@uswitch/ev-utils/lib/switch'
import loadable from '@loadable/component'
import withComponentBase from '../../helpers/with-component-base'

const FeaturedPosts = loadable(() => import('./featured-posts'))
const Default = loadable(() => import('./default'))

const ReadMoreModule = ({ variant, ...props }) =>
  sw({
    'featured posts': props => <FeaturedPosts {...props} />,
    default: props => <Default {...props} />,
  })(variant?.toLowerCase(), props)

export default withComponentBase(ReadMoreModule, {
  withContainer: true,
  withPalette: true,
  withHeaderFooter: true,
  headerStyles: {
    mt: 'lg',
  },
  footerStyles: {
    mb: 'lg',
  },
})
